import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import ReactMarkdown from 'react-markdown';
import { IBlogPost } from '../../models/strapi.models';
import { formatDate, getImageSrcWithFallback } from '../../shared/useUtils';
import { IAppPage } from '../../store/slices/appSlice';
import { BlogItemListStyle } from '../../styles/components/blog';

export interface IBlogItemProps extends IBlogPost {
  appPages: IAppPage[];
}

const BlogItemList = (props: IBlogItemProps) => {
  const router = useRouter();
  // Construct URL directly from slug (already comes with correct path from Strapi)
  const postUrl = props.slug
    ? `${router.locale !== 'en' ? `/${router.locale}` : ''}/${props.slug}`
    : '#';

  return (
    <article className={BlogItemListStyle.blogItemList}>
      <div className={BlogItemListStyle['content']}>
        <div className={BlogItemListStyle['thumbnail']}>
          <Image
            quality={100}
            fill
            sizes="(max-width: 768px) 100vw, 1000px"
            alt={props.image?.alternativeText || props.title}
            priority={true}
            src={
              getImageSrcWithFallback(props.image, 'medium') ||
              '/assets/images/blog/blog-placeholder-image.png'
            }
          />
        </div>
        <h2>
          <Link href={postUrl} className={BlogItemListStyle.titleLink}>
            {props.title}
          </Link>
        </h2>
        <div className={BlogItemListStyle['metadata']}>
          <p>
            <span>{props.author?.fullname || 'iGerent'}</span>
            {props.publicationDate && (
              <span>{formatDate(props.publicationDate)}</span>
            )}
          </p>
        </div>
        <ReactMarkdown>{props.metaDescription}</ReactMarkdown>
      </div>
    </article>
  );
};

export default BlogItemList;
